const driver = () => window.localStorage;

function localStorageManager(STORAGE_KEY: string) {
  return {
    getItem: () => JSON.parse((driver()).getItem(STORAGE_KEY) as string),
    setItem: (data: any) => (driver()).setItem(STORAGE_KEY, JSON.stringify(data)),
    removeItem: () => (driver()).removeItem(STORAGE_KEY),
    upsertItem: function (data: any){
      this.removeItem();
      this.setItem(data);
    },
  };
}

export default localStorageManager;
